<template>
    <div :class="color">
        <b-navbar toggleable="lg" :class="color" :type="color" fixed="top">
            <b-navbar-brand :href="$router.resolve({ name: 'home' }).href"><img class="logo" :src="logo" alt=""></b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
            
            <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto" style="position: relative;"> 
                    <b-nav-item :href="$router.resolve({ name: 'nosotros' }).href">Nosotros</b-nav-item>
                    <b-nav-item v-on:mouseover="subActive=true" v-on:mouseout="subActive=false" :href="$router.resolve({ name: 'proyectos' }).href">Proyectos
                        <div v-on:mouseover="subActive=true" v-show="subActive" class="submenu hide-desktop">
                            <b-dropdown-item :href="$router.resolve({ name: 'samara' }).href">Samara</b-dropdown-item>
                            <b-dropdown-item href="https://cotosur.mx/">Coto sur 2</b-dropdown-item>
                        </div>

                    </b-nav-item>
                    <b-nav-item class="hide-mobile" :href="$router.resolve({ name: 'samara' }).href">Samara</b-nav-item>
                    <b-nav-item class="hide-mobile" href="https://cotosur.mx/">Coto sur 2</b-nav-item>
                    
                    <b-nav-item class="btn-contact" :href="$router.resolve({ name: 'contacto' }).href">Contacto</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    export default {
        props: {
            color: {
                colorHead: String,
                default: 'light'
            },
            logo: {
                type: String,
                default: require('../assets/imgs/aria_azul.svg')
            }
        },
        data() {
            return {
                active: false,
                oldColor: '',
                oldLogo: '',
                productsCart: {},
                subActive: false
            };
        },
        methods: {
            changeColor(){
                this.active=!this.active
                if(this.active){
                    this.oldColor = this.color
                    this.color = 'light'
                    this.oldLogo = this.logo
                    this.logo = require('../assets/imgs/aria_azul.svg')
                } else {
                    this.color = this.oldColor
                    this.logo = this.oldLogo
                }
            }
        }
    }
</script>

<style scoped>
/* NAVBAR */
.navbar{
  padding: 15px 5% 5px 5%;
}
.light .navbar{
    background: #fff !important;
    border-bottom: 1px solid #000;
}
.transparent{
    background: transparent;
}

.nav-item .router-link-active{
    color: #000 !important;
    font-weight: 700 !important;
}
.light .btn-contact{
    background: #20234A;
    color: #fff !important;
    border-radius: 5px;
}
.transparent .btn-contact{
    background: #20234A66;
    color: #fff !important;
    border-radius: 5px;
}

.nav-link{
    position: relative;
}
.submenu{
    border-radius: 5px;
    position: absolute;
    color: #fff !important;
}
.light  .submenu{
    background: #20234A;
}
.transparent  .submenu{
    background: #20234A66;
}
.hide-mobile{
    display: none;
}
.light  .navbar-light .navbar-nav .btn-contact .nav-link{
    color: #fff !important;
}
.navbar-expand-lg .navbar-nav .nav-link{
    padding-left: 0px !important;
    padding-right: 0px !important;
    font-size: 20px;
    margin-left: 2rem;
    margin-right: 2rem;
}
.navbar-light .navbar-nav .nav-link{
    color: #000;
}

.transparent .navbar-nav .nav-link,
.navbar-dark .navbar-nav .nav-link{
    color: #fff;
}

.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus{
    color: #000;
    outline: none;
}
.navbar-nav{
    text-align: left !important;
}

@media (max-width: 1199px) and (min-width: 992px){
    .transparent .navbar-nav .nav-link,
    .navbar-light .navbar-nav .nav-link,
    .btn-request{
        line-height: 1 !important;
    }
}
@media (max-width: 992px){
    .hide-mobile{
        display: block;
    }
    .hide-desktop{
        display: none;
    }
    .scrollactive-nav{
        display: grid;
        margin-bottom: 10px;
    }
    .scrollactive-item{
        margin-top: 15px;
        font-size: 18px;
    }
    .logo{
        width: 125px;
        height: 26px;
    }
    hr {
        width: 170px;
        margin-left: 0px; 
    }
    .btn-request{
        width: 150px;
        line-height: 1;
    }
    .navbar-expand-lg .navbar-nav .nav-link{
        font-size: 18px;
    }
    .scrollactive-item{
        margin-top: 0px;
    }
    .navbar-nav{
        margin-top: 30px;
        margin-bottom: 20px;
    }
}
</style>